module.exports = __webpack_public_path__ + "30bce0ed7218b8f38f4fa82ac989cdbe.svg";